<template>
  <div class="pa-6">
    <h1>{{ pageTitle }}</h1>
    <v-tabs show-arrows class="mt-10">
      <v-tab :to="{ name: 'BaseProductsPage' }">
        {{ $t('global.newProductCatalogueMenu.baseProductsPage') }}
      </v-tab>
      <v-tab :to="{ name: 'DeviceListWithNewProduct' }">
        {{ $t('global.newProductCatalogueMenu.thingsPage') }}
      </v-tab>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'NewProductCataloguePage',
  computed: {
    pageTitle() {
      // Dynamically return the title based on the current route name
      const routeName = this.$route.name
      switch (routeName) {
        case 'BaseProductsPage':
          return this.$t('global.newProductCatalogueMenu.baseProductsPage')
        case 'DeviceListWithNewProduct':
          return this.$t('global.newProductCatalogueMenu.thingsPage')
        default:
          return this.$t('global.menu.productCatalogue')
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/variables.less';

h1 {
  font-size: 24px;
}

/deep/.v-slide-group {
  background-color: tint(@color-brand-highlight, 50%) !important;
  margin-bottom: 30px;

  .v-tab {
    color: @color-brand-2 !important;
    opacity: 0.5;

    &--active {
      opacity: 1;
    }

    &:hover {
      text-decoration: none;
    }
  }

  .v-tabs-slider-wrapper {
    color: @color-brand-2 !important;
  }
}
</style>
